export const sxConfig = {
  eventTime: {
    fontWeight: 'bold',
    fontSize: '0.9rem',
  },
  eventTitle: {
    fontSize: '1.05rem',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
  },
  eventIconBox: {
    display: 'inline-block',
    verticalAlign: 'middle',
    px: 0.5,
  },
  eventBox: {
    p: 0.35,
    overflow: 'hidden',
    width: '100%',
    //borderRadius: 1,
  },

  tooltip: {
    color: '#514E6A',
    backgroundColor: '#ffff',
    boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
    minWidth: 300,
    maxWidth: '100%',
  },

  tooltipArrow: {
    color: '#ffff',
  },

  tooltipContent: {
    display: 'flex',
    justifyContent: 'space-between',
  },

  tooltipContentFirstTyp: {
    fontWeight: 'bold',
  },

  reportIconContainer: {
    textAlign: 'right',
  },

  reportIconButton: {
    m: 0,
    p: 0,
  },

  reportIcon: {
    color: '#0065F8',
    fontSize: '1.8rem',
    '&:hover': {
      color: 'gray',
    },
  },
};
